export default {
	Easy: ['Bob', 'Charlie', 'Eve'],
	Medium: ['Bob', 'Sophie', 'Alice'],
	Hard: ['Bob', 'Hank', 'Grace'],
	CrazyNinja: ['Bob','Grace','Nadia'],

};